module.exports = __webpack_public_path__ + "static/media/1500-point-season.d76106df.png";